
import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import {
  clearToken,
  getCandidateToken,
  getCompanyToken,
  getSchoolToken,
} from "@/functions/token.function";
import { Action, State } from "vuex-class";
import filters from "@/filters";
import {
  AdminJobFairTransactionCategoryEnum,
  EnumHelper,
  NotificationTypeEnum,
} from "@/constants/enum.constant";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { Notification } from "@/store/types";

type NotificationResponse = AxiosResponse<
  ServerResponse<LaravelPagination<Notification>>
>;

@Component({
  components: {},
  filters,
})
export default class AppNavbar extends Vue {
  @Action("getAdminJobFairCandidateProfile", { namespace: "admin" })
  private getAdminJobFairCandidateProfile: any;

  @Action("getNotification", { namespace: "school" })
  private getSchoolNotification!: (
    options?: AxiosRequestConfig
  ) => Promise<NotificationResponse>;
  @Action("getNotification", { namespace: "company" })
  private getCompanyNotification!: (
    options?: AxiosRequestConfig
  ) => Promise<NotificationResponse>;

  @State("candidate", { namespace: "admin" })
  private candidate!: any;

  private notificationTypes = EnumHelper(NotificationTypeEnum);
  private notifications: Array<Notification> = [];
  private notification: Notification | null = null;

  private categories = EnumHelper(AdminJobFairTransactionCategoryEnum).map(
    (value) => ({
      ...value,
      translation: (
        this.$t(`category_${value.name.toLowerCase()}`) as any
      ).replaceAll(" {organizer}", ""),
    })
  );

  private created() {
    if (getCandidateToken() && this.$route.name === "company-detail") {
      this.getAdminJobFairCandidateProfile();
    }

    const transform = (items: Notification[]) => {
      return items.map((item) => {
        return Object.assign(item, {
          notificationTypeName: this.notificationTypes.find(
            (value) => value.id === item.type
          )?.name,
        });
      });
    };

    if (getSchoolToken()) {
      this.getSchoolNotification({ errorRedirect: false }).then(
        ({ data: { data: pagination } }) => {
          this.notifications = transform(pagination.data);
        }
      );
    } else if (getCompanyToken()) {
      this.getCompanyNotification({ errorRedirect: false }).then(
        ({ data: { data: pagination } }) => {
          this.notifications = transform(pagination.data);
        }
      );
    }
  }

  private get showLogout() {
    switch (this.$route.name) {
      case "school-dashboard":
        return !!getSchoolToken();
      case "job-fair-detail":
      case "company-detail":
        return !!this.candidate;
      case "company-dashboard":
        return !!getCompanyToken();
      default:
        return false;
    }
  }

  private get badge() {
    switch (this.$route.name) {
      case "school-dashboard":
        return "Organizer";
      case "job-fair-detail":
      case "company-detail":
        return "Applicant";
      case "company-dashboard":
        return "Company";
      default:
        return "Events";
    }
  }

  private navbarToggle() {
    $("#main-nav").toggleClass("navbar-expanded");
    $("#nav-mobile").toggleClass("show");
  }

  private logout() {
    clearToken();
    this.$router.go(0);
  }

  seeDetail(notification: Notification) {
    // const { name } = this.$route;
    // switch (notification.type) {
    //   case NotificationTypeEnum.CANDIDATE:
    //     if (name !== "candidates") {
    //       this.$router.push({
    //         name: "candidates",
    //       });
    //     }
    //     break;
    //   case NotificationTypeEnum.TRACER_STUDY:
    //     if (name !== "tracer-study-detail") {
    //       this.$router.push({
    //         name: "tracer-study-detail",
    //         params: {
    //           id: notification.data?.tracer_study_id,
    //         },
    //       });
    //     } else {
    //       this.$router.replace({
    //         name: "tracer-study-detail",
    //         params: {
    //           id: notification.data?.tracer_study_id,
    //         },
    //       });
    //     }
    //     break;
    //   case NotificationTypeEnum.PARTNERSHIP:
    //     if (notification?.data?.company_id) {
    //       if (name !== "company-detail") {
    //         this.$router.push({
    //           name: "company-detail",
    //           params: {
    //             id: notification?.data?.company_id,
    //           },
    //         });
    //       } else {
    //         this.$router.replace({
    //           name: "company-detail",
    //           params: {
    //             id: notification?.data?.company_id,
    //           },
    //         });
    //       }
    //     } else if (name !== "companies") {
    //       this.$router.push({
    //         name: "companies",
    //       });
    //     }
    //     break;
    //   case NotificationTypeEnum.SCHOOL_SUBSCRIPTION:
    //     if (name !== "subscription") {
    //       this.$router.push({
    //         name: "subscription",
    //       });
    //     }
    //     break;
    //   case NotificationTypeEnum.SCHOOL_EVENT:
    //     if (name !== "event-detail") {
    //       this.$router.push({
    //         name: "event-detail",
    //         params: {
    //           id: notification?.data?.event_id,
    //         },
    //       });
    //     } else {
    //       this.$router.replace({
    //         name: "event-detail",
    //         params: {
    //           id: notification?.data?.event_id,
    //         },
    //       });
    //     }
    //     break;
    //   case NotificationTypeEnum.SCHOOL_VERIFICATION:
    //     if (name !== "dashboard") {
    //       this.$router.push({
    //         name: "dashboard",
    //       });
    //     }
    //     break;
    //   default:
    //     this.notification = notification;
    //     // this.modal.detail = true;
    //     break;
    // }
  }
}
